import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {useFormik} from 'formik';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { regex } from '@capsovision/capso_utils';
import Button from '@mui/material/Button';
import Request from '../../components/AxiosInstance';
import {useNavigate} from 'react-router-dom';
import StateSelect from '../../components/UI/StateSelect';


export default function UpdateAddress({user}) {

	const navigate = useNavigate();

	const handleSubmit = async (values) => {
		const { address, address2, city, state, zip } = values;

		try {
			await Request.put('/api/account/address', { address, address2, city, state, zip });
			toast.success('Address updated');
			navigate('/acc');
		} catch (e) {
			console.error(e);
		}
	}

	const formik = useFormik({
		initialValues: {
			address: user.address || '',
			address2: user.address2 || '',
			city: user.city || '',
			state: user.state || '',
			zip: user.zip || ''
		},
		enableReinitialize: true,
		validationSchema: yup.object({
			address: yup
				.string()
				.required('Address is required'),
			address2: yup
				.string(),
			city: yup
				.string()
				.required('City is required'),
			state: yup
				.string()
				.required('State is required'),
			zip: yup
				.string()
				.required('Zip code is required')
				.matches(regex.zip, 'Zip format is invalid'),
		}),
		onSubmit: async (values) => {
			await handleSubmit(values);
		},
	});

	return (
		<Container component="main" maxWidth="sm">
		<Typography variant="h5" sx={{ pb: 2 }}>
			Update Address
		</Typography>
		<form onSubmit={formik.handleSubmit}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="address"
						name="address"
						label="Address 1"
						fullWidth
						autoComplete="shipping address-line1"
						variant="outlined"
						value={formik.values.address}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						error={formik.touched.address && Boolean(formik.errors.address)}
						helperText={formik.touched.address && formik.errors.address}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						id="address2"
						name="address2"
						label="Address 2 (Optional)"
						fullWidth
						autoComplete="shipping address-line2"
						variant="outlined"
						value={formik.values.address2}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						required
						id="city"
						name="city"
						label="City"
						fullWidth
						autoComplete="shipping address-level2"
						variant="outlined"
						value={formik.values.city}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						error={formik.touched.city && Boolean(formik.errors.city)}
						helperText={formik.touched.city && formik.errors.city}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<StateSelect
						required
						id="state"
						name="state"
						autoComplete="shipping address-level1"
						value={formik.values.state}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						error={formik.touched.state && Boolean(formik.errors.state)}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						required
						id="zip"
						name="zip"
						label="Zip code"
						fullWidth
						autoComplete="shipping postal-code"
						variant="outlined"
						value={formik.values.zip}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						error={formik.touched.zip && Boolean(formik.errors.zip)}
						helperText={formik.touched.zip && formik.errors.zip}
					/>
				</Grid>
			</Grid>
			<Button
				type="submit"
				fullWidth
				variant="contained"
				sx={{ mt: 3, mb: 2 }}
			>
				Submit
			</Button>
		</form>
	</Container>
	)
}
